import React from 'react';
import { MeetingDetailsContextProvider } from '../../../services/meeting-details/meeting-details.context';
import { MeetingDetails } from './meeting-details';

export const MeetingDetailsContainer = (props) => {
  const {
    location: { state = '' },
  } = props;

  return (
    <MeetingDetailsContextProvider>
      <MeetingDetails state={state} />
    </MeetingDetailsContextProvider>
  );
};
